import { SyncType } from "types";

export interface FetchConnectionPayload {
    ClientId: string;
    ConnectionIds: string[];
    StartYear: number;
    FetchType: SyncType;
    DeltaFromUtc?: string;
}

export interface FileServerCredentials {
    type: FileServerType;
    host: string;
    username: string;
    password: string;
}

export enum FileServerType {
    SFTP = 1
}

export interface FileServerPath {
    path: string;
    isFolder: boolean;
}

export interface CreateFileServerConnectionPayload {
    clientId: string;
    identifier: string;
    format: string;
    credentials: FileServerCredentials;
    paths: FileServerPath[];
    fileNameRegex?: string;
}